module.exports = __webpack_public_path__ + "img/loginw.a2229edb.png";